import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { NavigateComponent } from "./pick-up/navigate/navigate.component";

import { APPLICATION_ROUTES } from "./shared/constants/app-routes";
import { PermalinkGuard } from "./shared/guard/permalink.guard";
const routes: Routes = [
	{
		path: "",
		redirectTo: APPLICATION_ROUTES.BASE_URL,
		pathMatch: "full",
	},
	{
		path: "indian-food-fair",
		component: NavigateComponent,
		pathMatch: "full",
	},
	{
		path: 'maps',
		loadChildren: () => import('./maps/maps.module').then(m => m.MapsPageModule)
	},
	{
		path: `${APPLICATION_ROUTES.BASE_URL}/:restaurantName/:utmId`,
		canActivate: [PermalinkGuard],
		loadChildren: () =>
			import("./pick-up/pick-up.module").then((m) => m.PickUpPageModule),
	},
	{
		path: APPLICATION_ROUTES.BASE_URL,
		children: [
			{
				path: "",
				loadChildren: () =>
					import("./master-landing/master-landing.module").then(
						(m) => m.MasterLandingPageModule,
					),
			},
			{
				path: APPLICATION_ROUTES.RESERVATION,
				loadChildren: () =>
					import("./reservation/reservation.module").then(
						(m) => m.ReservationPageModule,
					),
			},
			{
				path: APPLICATION_ROUTES.FEEDBACK + "/:businessId/:orderId",
				loadChildren: () =>
					import("./pickup-feedback/pickup-feedback.module").then(
						(m) => m.PickupFeedbackPageModule,
					),
			},
		],
	},
	{
		path: ":restaurant",
		children: [
			{
				path: "",
				loadChildren: () =>
					import("./pick-up/pick-up.module").then((m) => m.PickUpPageModule),
			},
			{
				path: APPLICATION_ROUTES.RESERVATION,
				loadChildren: () =>
					import("./reservation/reservation.module").then(
						(m) => m.ReservationPageModule,
					),
			},
		],
	},
	{
		path: "restaurants",
		loadChildren: () =>
			import("./restaurants/restaurants.module").then(
				(m) => m.RestaurantsPageModule,
			),
	},

];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
